export enum LeadActivityIcon {
    PhoneCall = 1,
    Email = 2,
    WebsiteForm = 3,
    Meeting = 4,
    FollowUp = 5,
    None = 6,
    Users = 7,
    Flag = 8,
    Drop = 9,
    File = 10,
    Comments = 11,
}
